import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from '@/helpers/classNames'
import RichTextEditor from '@/ui/RTE/Medium'
import InlineEdit from '@/ui/Input/Content'
import {
  RTE as RteText,
  HEADER as HeaderText,
  BUTTON as ButtonText,
  NOIMAGE as NoImageText,
} from '@/state/types/defaultLabel'

class TextBlock extends Component {
  static displayName = 'Card / Image + Text'

  static propTypes = {
    item: PropTypes.object.isRequired,
    cta: PropTypes.bool,
    theme: PropTypes.object.isRequired,
  }

  static defaultProps = {
    cta: true,
  }

  render() {
    const { item, theme, active, onChange, newsletterId, cta } = this.props
    const { id, image, text = RteText, header = HeaderText, buttontext = ButtonText } = item

    return (
      <div className={classNames(theme, 'renderpreview', 'imagetext-preview')}>
        <Choose>
          <When condition={image}>
            <Choose>
              <When condition={typeof image === 'object'}>
                <img src={image.src} alt="" />
              </When>
              <Otherwise>
                <img
                  src={`${process.env.URL}/newsletters/${String(newsletterId).padStart(
                    4,
                    '0',
                  )}/${image}`}
                  alt=""
                />
              </Otherwise>
            </Choose>
          </When>
          <Otherwise>
            <div className={theme['empty-image']}>
              <span>{NoImageText}</span>
            </div>
          </Otherwise>
        </Choose>
        <div className={theme['innerwrap']}>
          <Choose>
            <When condition={active}>
              <InlineEdit
                tagName="h1"
                html={header}
                textual
                selectText={HeaderText}
                onChange={(e, value) => onChange(this.props.item, 'header', value)}
              />
              <RichTextEditor
                id="text"
                name="text"
                key={`rte${id}`}
                value={text}
                selectText={RteText}
                onChange={value => onChange(this.props.item, 'text', value)}
              />
            </When>
            <Otherwise>
              <h1>{header}</h1>
              <div dangerouslySetInnerHTML={{ __html: text }} />
            </Otherwise>
          </Choose>
          <If condition={cta}>
            <button
              className={classNames(theme, 'button', 'button-outline')}
              style={{ marginTop: '24px', padding: '16px' }}
            >
              {buttontext}
            </button>
          </If>
        </div>
      </div>
    )
  }
}

export default TextBlock



// WEBPACK FOOTER //
// ./ui/Blocks/ImageText.js